// @flow
import React from "react";
import type { IconProps } from "../";

type Props = {
  ...IconProps,
  className?: string,
  onClick?: () => void
};

export default function WithdrawSuccess({ width = "56px", ...props }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 56 56"
      width={width}
      {...props}
    >
      <g transform="translate(0 -0.063)">
        <g transform="translate(9.653 0.063)">
          <path
            fill="#44c4a1"
            d="M124.934,91.453a2.27,2.27,0,0,0-.338-1.2l-2.153-3.466a3.8,3.8,0,0,1-.405-1.719V74.393a12.55,12.55,0,0,0-12.549-12.552H103.7A12.55,12.55,0,0,0,91.149,74.393V85.071a3.793,3.793,0,0,1-.405,1.719l-2.153,3.466a2.27,2.27,0,0,0-.338,1.2h0A2.258,2.258,0,0,0,90.5,93.7h32.182A2.258,2.258,0,0,0,124.934,91.453Z"
            transform="translate(-88.253 -55.082)"
          />
          <path
            fill="#44c4a1"
            d="M195.953,6.822,200.779.063H185.335l4.826,6.759V8.753h5.792Z"
            transform="translate(-174.717 -0.063)"
          />
        </g>
        <path
          fill="#3ea69b"
          d="M213.968,129.556l-2.153-3.466a3.8,3.8,0,0,1-.405-1.719V113.692a12.55,12.55,0,0,0-2.635-7.724c-2.577,14.2-11.651,22.39-20.174,27.035h23.456a2.26,2.26,0,0,0,1.931-3.447Z"
          transform="translate(-167.972 -94.319)"
        />
        <path
          fill="#fff"
          d="M221.376,147.063v-.618a3.253,3.253,0,0,0-3.243-3.244h-.618V141.27h-1.931V143.2h-.618a3.244,3.244,0,0,0-1.139,6.285l1.757.656v3.679h-.618a1.313,1.313,0,0,1-1.313-1.313h0v-.618h-1.931v.618a3.253,3.253,0,0,0,3.243,3.244h3.166a3.244,3.244,0,0,0,1.139-6.285l-1.757-.657v-3.679h.618a1.313,1.313,0,0,1,1.313,1.313h0v.618Zm-2.78,4.21a1.333,1.333,0,0,1,.849,1.236,1.313,1.313,0,0,1-1.313,1.313h-.618v-2.954Zm-3.012-3.186-1.081-.406a1.333,1.333,0,0,1-.849-1.236,1.313,1.313,0,0,1,1.313-1.313h.618Z"
          transform="translate(-188.557 -125.759)"
        />
        <g transform="translate(0 1.994)">
          <path
            fill="#fdb62f"
            d="M401.006,25.437h0a4.692,4.692,0,0,0-3.861-3.862h0a4.692,4.692,0,0,0,3.861-3.862h0a4.692,4.692,0,0,0,3.861,3.862h0A4.692,4.692,0,0,0,401.006,25.437Z"
            transform="translate(-353.707 -17.713)"
          />
          <path
            fill="#fdb62f"
            d="M3.861,201.947h0A4.691,4.691,0,0,0,0,198.085H0a4.692,4.692,0,0,0,3.861-3.862h0a4.692,4.692,0,0,0,3.861,3.862h0A4.691,4.691,0,0,0,3.861,201.947Z"
            transform="translate(0 -174.913)"
          />
        </g>
        <path
          fill="#fec9a3"
          d="M94.872,269.547a2.9,2.9,0,0,0-3.861-1.072l-13.7,5.851a1.937,1.937,0,0,1-.763.154H59.571a1.931,1.931,0,0,1,0-3.862h7.722a5.792,5.792,0,0,0,5.792-5.793H57.023a8.776,8.776,0,0,0-6.844,3.292l-6.052,7.328,6.815,12.494,26.227-6.3a13.925,13.925,0,0,0,3.263-1.2l13.514-6.923A2.9,2.9,0,0,0,94.872,269.547Z"
          transform="translate(-39.301 -235.798)"
        />
        <path
          fill="#f7bb8f"
          d="M86.578,380.483l2.172,3.978,26.227-6.3a13.927,13.927,0,0,0,3.263-1.2l7.307-3.756C113.4,376.92,97.283,379.237,86.578,380.483Z"
          transform="translate(-77.109 -332.318)"
        />
        <path
          fill="#4398d1"
          d="M0,329.5v17.379H12.549l2.9-2.9L3.861,326.605Z"
          transform="translate(0 -290.818)"
        />
        <path
          fill="#3e8cc7"
          d="M0,462.422H12.549l2.9-2.9-2.124-3.186A68.254,68.254,0,0,1,0,460.307Z"
          transform="translate(0 -406.359)"
        />
        <ellipse
          fill="#d9d9d9"
          cx="1.931"
          cy="1.931"
          rx="1.931"
          ry="1.931"
          transform="translate(6.757 49.307)"
        />
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/Icons/Announcements/WithdrawSuccess.js